import { useState } from 'react'
import searchIcon from '../../../assets/icons/search.png'
import filterIcon from '../../../assets/icons/filter.png'
import { Link } from 'react-router-dom'
import './styles.sass'

export default function SearchInput() {
    const [search, setSearch] = useState('')
    return (
        <div className='oportunities-searcher'>
            <Link to={search ? 'offers?search='+search : 'offers'}><img className='search-icon' src={searchIcon} alt='search-icon' /></Link>
            <input type='text' placeholder='Pesquisar vaga' value={search} onChange={e => setSearch(e.target.value)} />
            <img className='filter-icon' src={filterIcon} alt='filter-icon' />
        </div>
    )
}